export const IMG = {
  hero: "/products/jeans-front.webp",
  jeansSide: "/products/jeans-side.webp",
  jeansZipper: "/products/jeans-zipper.webp",
  sbrComposed: "/products/v3/sbr-tee-front.webp",
  sbrDetail: "/products/v3/sbr-tee-detail.webp",
  skullComposed: "/products/v3/skull-composed.webp",
  sweatComposed: "/products/v3/sweat-composed.webp",
  beltStarComposed: "/products/v3/belt-star-composed.webp",
  wonderComposed: "/products/v3/wonder-composed.webp",
  whiteTeePhoto: "/products/v3/white-photo-front.webp",
};

export const INSTAGRAM_URL = "https://instagram.com/requiemfever";
export const INSTAGRAM_HANDLE = "@requiemfever";
// Opens a DM thread with the shop directly (mobile: Instagram app).
export const INSTAGRAM_DM_URL = "https://ig.me/m/requiemfever";
export const SUPPORT_EMAIL = "support@requiemfever.in";

export const inr = (n) => "₹" + Number(n).toLocaleString("en-IN");

export const POLICIES = {
  shipping: {
    title: "SHIPPING",
    sections: [
      {
        h: "WITHIN INDIA",
        p: "We ship to every serviceable pin code across India. Shipping is free on all orders — no minimum spend.",
      },
      {
        h: "DISPATCH & DELIVERY",
        p: "Orders are dispatched within 2–3 business days. Delivery is estimated within 15–20 days, depending on your location. You will receive a tracking link as soon as your order ships.",
      },
      {
        h: "INTERNATIONAL",
        p: "International shipping is not available yet. Follow us on Instagram @requiemfever for announcements.",
      },
    ],
  },
  returns: {
    title: "RETURNS & EXCHANGES",
    sections: [
      {
        h: "7-DAY WINDOW",
        p: "You can request a return or exchange within 7 days of delivery. Items must be unworn, unwashed and have all original tags attached.",
      },
      {
        h: "EXCHANGES",
        p: "Size exchanges are subject to stock availability. If the size you want is available, we will ship it as soon as the original piece reaches us.",
      },
      {
        h: "REFUNDS",
        p: "Refunds are issued to your original payment method once the returned item passes our quality check. Shipping charges, if any were levied, are non-refundable.",
      },
      {
        h: "NOT ELIGIBLE",
        p: "For hygiene reasons, items that have been worn, washed or had tags removed cannot be returned or exchanged.",
      },
    ],
  },
  privacy: {
    title: "PRIVACY POLICY",
    sections: [
      {
        h: "WHAT WE COLLECT",
        p: "We collect only what we need to fulfil your order: your name, contact details, shipping address and order history. Payment details are processed by our payment gateway and are never stored on our servers.",
      },
      {
        h: "HOW WE USE IT",
        p: "Your information is used to process orders, provide support and — if you opt in — send you occasional updates about new drops. We do not sell or share your personal data with third parties for marketing.",
      },
      {
        h: "YOUR CHOICES",
        p: "You can ask us to access, correct or delete your personal information at any time by writing to our support email.",
      },
    ],
  },
  terms: {
    title: "TERMS & CONDITIONS",
    sections: [
      {
        h: "THE BASICS",
        p: "By placing an order on this site you agree to these terms. All prices are listed in Indian Rupees (INR) and include applicable taxes.",
      },
      {
        h: "ORDERS & PRICING",
        p: "We reserve the right to cancel an order in the rare case of a pricing error or stock unavailability, with a full refund issued immediately.",
      },
      {
        h: "PRODUCT REPRESENTATION",
        p: "We photograph our products under studio lighting; slight colour variation between the screen and the garment is possible.",
      },
      {
        h: "INTELLECTUAL PROPERTY",
        p: "All imagery, copy and designs on this site belong to REQUIEM FEVER and may not be reproduced without permission.",
      },
    ],
  },
};
